import React from 'react'
import { Link } from 'gatsby'

class Layout extends React.Component {
  render() {
    const { children } = this.props

    return (
      <div>
        <header>
          <h1>
            <Link className="site-name" to={'/'}>
              Creative Works
            </Link>
          </h1>
          <a
            href="https://berraknil.github.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            by berrak
          </a>
        </header>
        {children}
      </div>
    )
  }
}

export default Layout
